// Fechas operativas en hora de Guatemala (UTC-6).
//
// NUNCA usar `new Date().toISOString().slice(0, 10)` para "hoy":
// toISOString() convierte a UTC, y después de las 18:00 locales eso ya
// es MAÑANA. Bug real del 11-ago-2026: depósitos registrados de noche
// quedaron con fecha futura (el espejo en DB es la migración 0158, que
// arregló los defaults CURRENT_DATE/CURRENT_TIME del servidor).

const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Guatemala' })

/** YYYY-MM-DD de hoy en Guatemala. */
export const hoyGT = () => fmt.format(new Date())

/** YYYY-MM-DD de hace n días, en Guatemala. */
export const haceDiasGT = (n: number) => {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return fmt.format(d)
}

/** YYYY-MM-DD de un instante dado, visto desde Guatemala. */
export const fechaGT = (d: Date) => fmt.format(d)
